document.addEventListener('turbo:load', (_event) => {
  document.querySelectorAll('.onspace-markdown figure[id]').forEach((figure) => {
    figure.querySelectorAll('.figure__callout').forEach((callout) => {
      const calloutId = callout.getIntegerAttribute('data-callout')
      const reference = document.querySelector(`.onspace-markdown .figure-reference[data-id="${figure.id}"][data-callout="${calloutId}"]`)

      callout.addEventListener('mouseover', (_event) => {
        figure.classList.add('figure--callout-highlight')
        callout.classList.add('figure__callout--highlight')
        reference.classList.add('figure-reference--highlight')
      })
      callout.addEventListener('mouseout', (_event) => {
        figure.classList.remove('figure--callout-highlight')
        callout.classList.remove('figure__callout--highlight')
        reference.classList.remove('figure-reference--highlight')
      })

      reference.addEventListener('mouseover', (_event) => {
        figure.classList.add('figure--callout-highlight')
        callout.classList.add('figure__callout--highlight')
        reference.classList.add('figure-reference--highlight')
      })
      reference.addEventListener('mouseout', (_event) => {
        figure.classList.remove('figure--callout-highlight')
        callout.classList.remove('figure__callout--highlight')
        reference.classList.remove('figure-reference--highlight')
      })
    })
  })
})
